export enum ViajeMensajeriaTipoServicio {
  EJECUTIVO = 'Ejecutivo',
  VIP = 'VIP',
  UTILITARIO = 'Utilitario'
}

export function tiposDeServicioViajeMensajeria() {
  return Object.values(ViajeMensajeriaTipoServicio).sort();
}
